export function toggleOpenOptions (optionsType) {
  if (this.openOptions === optionsType) {
    this.openOptions = null
  } else {
    this.openOptions = optionsType
  }
}

export function goNext (itemsInView) {
  this.startIndex += itemsInView
}

export function goPrev (itemsInView) {
  this.startIndex -= itemsInView
  if (this.startIndex < 1) {
    this.startIndex = 0
  }
}

export function changeSelectedCount (option) {
  this.selectedCount = option
  this.openOptions = null
}
